import { render, staticRenderFns } from "./sites.vue?vue&type=template&id=27c93001"
import script from "./sites.vue?vue&type=script&lang=ts"
export * from "./sites.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports